import MainRoutes from 'src/app/main/main-routing'
import DashboardRoutes from 'src/app/dashboard/dashboard-routing'
import OnboardingRoutes from 'src/app/onboarding/onboarding-routing'
import LandingScreen from './main/landingScreen'
import AcctDeletionRoutes from './accountDeletion/acct-deletion-routing'

export default [
    MainRoutes,
    OnboardingRoutes,
    DashboardRoutes,
    LandingScreen,
    AcctDeletionRoutes
]